<template>
  <div>
    <div class="the-footer-holder"></div>
    <div class="the-footer tac">
      <FrameHeaderLink/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'footermy',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  // 说明：footer 样式 配合 .frame-wrap 处理

  .the-footer{
    background-color: $c_bg;
    padding: 5px 0;

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    /deep/ a{
      color: $c2 !important;
      font-size: 1.4em;
    }
  }

  .the-footer-holder{
    height: 80px;
  }
</style>